import { Column } from '@dixa/lib-shared-habla';
import classNames from 'classnames';
import { PropsWithChildren } from 'lib-shared-types-utils';
import { ComponentProps, forwardRef } from 'react';

import styles from './conditionFieldLayoutRow.module.scss';

type ConditionFieldLayoutRowProps = {
  noPadding?: boolean;
} & ComponentProps<typeof Column.Row> &
  PropsWithChildren;

export const ConditionFieldLayoutRow = forwardRef<
  HTMLDivElement,
  ConditionFieldLayoutRowProps
>(function ConditionFieldLayoutRow(
  { children, noPadding = false, ...rowProps },
  ref,
): JSX.Element {
  return (
    <Column.Row
      ref={ref}
      className={classNames(styles.root, {
        [styles.padded]: !noPadding,
        [styles.scrollable]: rowProps.scrollable,
      })}
      noHorizontalPadding
      noVerticalPadding
      noMinHeight
      {...rowProps}
    >
      {children}
    </Column.Row>
  );
});
